import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../config/api-urls/api-urls';
import { MainService } from '../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html'
})
export class MyProfileComponent implements OnInit {

  profileData: any = {};
  editProfileStatus: boolean = false;
  imageType: any;
  file: any;
  imageUrl: any;
  form: FormGroup | any;
  countryArr: any = [];
  constructor(private router: Router, public mainService: MainService) { }

  ngOnInit() {
    this.getProfile();
    this.formValidation();
    this.getCountryCodeData();

  }
  changePassword() {
    this.router.navigate(['change-password'])
  }

  // get profile
  getProfile() {
    this.mainService.showSpinner()
    this.mainService.getApi(ApiUrls.profile, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.profileData = res.result;
        this.imageUrl = this.profileData.profilePic
        this.form.patchValue({
          'firstName': this.profileData.firstName,
          'lastName': this.profileData.lastName,
          "email": this.profileData.email,
          "phoneNumber": this.profileData.mobileNumber,
          phone_code: this.profileData.countryCode
        })
        this.mainService.hideSpinner();
      } else {
        this.mainService.hideSpinner();
      }
    })
  }

  editApi() {
    this.editProfileStatus = true;

  }

  updateApi() {


    const data = {
      firstName: this.form.value.firstName,
      lastName: this.form.value.lastName,
      email: this.form.value.email,
      mobileNumber: this.form.value.phoneNumber,
      countryCode: this.form.value.phone_code,
      profilePic: this.imageUrl
    }
    this.mainService.putApi(ApiUrls.editProfile, data, 3).subscribe((res) => {
      if (res.responseCode == 200) {
        this.mainService.successToast(res.responseMessage);
        this.getProfile();
        this.editProfileStatus = false;
        this.imageUrl = res.result.profilePic;
        this.mainService.profileData.next(this.imageUrl);
      }
      else {
        this.mainService.errorToast(res.responseMessage);

      }
    }, err => {
      this.mainService.errorToast(err.responseMessage);
    })
  }

  back() {
    this.editProfileStatus = false;
  }

  editprofile() {
    this.editProfileStatus = false;

  }

  ValidateFileUpload(event: any) {
    this.file = event.target.files;
    if (this.file[0]) {
      this.imageType = this.file[0].type;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result;
        this.uploadImage()
      };
      reader.readAsDataURL(this.file[0]);
    }
  }

  // upload Image api integration 
  uploadImage() {
    const formData: FormData = new FormData();
    formData.append('image', this.file[0]);
    this.mainService.showSpinner()
    this.mainService.postApi(ApiUrls.uploadImage, formData, 3).subscribe((res) => {
      this.mainService.hideSpinner()
      if (res.responseCode == 200) {
        this.imageUrl = res.result.image;
      }
    })
  }


  getCountryCodeData() {
    this.mainService.getCountryCode().subscribe((res) => {
      this.countryArr = res
    })
  }

  formValidation() {
    this.form = new FormGroup({
      'firstName': new FormControl({ value: '', disabled: false }, Validators.compose([Validators.required, Validators.maxLength(62), Validators.pattern(/^[^\s][a-zA-Z ]*$/)])),
      'lastName': new FormControl({ value: '', disabled: false }),
      'phone_code': new FormControl({ value: '', disabled: false }),
      "email": new FormControl({ value: '', disabled: true }),
      "phoneNumber": new FormControl({ value: '', disabled: false }, ([Validators.required, Validators.pattern(/^[1-9][0-9]{9,13}$/)])),

    })
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }

}
